import {Controller} from "@hotwired/stimulus"

// Purchase Order Shipments list: expanding a shipment's SKU rows, and saving an
// ETA inline.
//
// Replaces an inline :javascript block bound in `$(document).ready`. That rebinds on
// every Turbolinks visit, so after a few navigations one change fired several PATCH
// requests. It also carried its own jQuery `$.ajax`; this uses fetch and sends the
// CSRF token by hand, which rails-ujs was doing invisibly before.
export default class extends Controller {
    toggleRows(event) {
        const button = event.currentTarget
        const row = document.getElementById(button.dataset.targetRow)
        if (!row) return

        const open = row.classList.toggle("ice:hidden") === false
        button.setAttribute("aria-expanded", open ? "true" : "false")

        const chevron = button.querySelector("i")
        if (chevron) {
            chevron.classList.toggle("fa-chevron-right", !open)
            chevron.classList.toggle("fa-chevron-down", open)
        }
    }

    // The ETA is the only editable field on this page, and it saves on change with
    // no confirm — unlike the purchase order page, where changing a shipment ETA is
    // a bigger deal because that is the date quoted to the vendor.
    saveEta(event) {
        const field = event.currentTarget
        const previous = field.dataset.originalValue || ""
        if (previous === field.value) return

        fetch(field.dataset.url, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-CSRF-Token": this.csrfToken,
                "X-Requested-With": "XMLHttpRequest"
            },
            credentials: "same-origin",
            body: JSON.stringify({shipment: {eta: field.value}})
        })
            .then((response) => {
                if (!response.ok) throw new Error(`${response.status} ${response.statusText}`)
                return response.json()
            })
            .then((body) => {
                // The endpoint answers 200 with {success: false} on a validation
                // failure, so the status alone is not enough to go on.
                if (!body || body.success !== true) throw new Error("The shipment was not saved")

                field.dataset.originalValue = field.value
                this.flash(field, "ice:border-success-300")
            })
            .catch((error) => {
                // Put the old value back: a field showing a date the server rejected
                // is worse than no feedback at all.
                field.value = previous
                this.flash(field, "ice:border-danger-300")
                window.alert(`Could not update the ETA: ${error.message}`)
            })
    }

    flash(field, toneClass) {
        field.classList.remove("ice:border-slate-200")
        field.classList.add(toneClass)

        window.setTimeout(() => {
            field.classList.remove(toneClass)
            field.classList.add("ice:border-slate-200")
        }, 1200)
    }

    get csrfToken() {
        const meta = document.querySelector("meta[name='csrf-token']")
        return meta ? meta.content : ""
    }
}
